import React from "react";
import { Col, Row } from "antd";
import styled from "styled-components";
// import imgpsh from "src/assets/images/careers/imgpsh.png";
// import imgpsh_fullsize from "src/assets/images/careers/imgpsh_fullsize.png";

const Content = styled.section`
  padding: 0px 20px 0px 20px;
`;

const Title = styled.h2`
  font-size: 30px;
  text-align: center;
  color: white;
  font-weight: 700;
  @media screen and (max-width: 500px) {
    font-size: 20px;
  }
`;

// const ImgTitle = styled.img`
//   width: 100%;
//   margin-top: 5%;
// `;

const Description = styled.p`
  font-size: 16px;
  color: white;
  text-align: center;
  @media screen and (max-width: 500px) {
    font-size: 12px;
  }
`;

const CareerTitle = () => {
  return (
    <Content>
      <Title>CAREERS</Title>
      <Description>
        We’re looking for talented, passionate, and creative individuals to join
        our young, dynamic and fast-growing team to help build top quality games
        that bring excitement and financial opportunities for people all around
        the world.
      </Description>
      {/* <Row justify="space-between" align="middle">
        <Col xs={4}>
          <ImgTitle src={imgpsh_fullsize} alt="" width={100} />
        </Col>
        <Col xs={16}>
          <Title>CAREERS</Title>
          <Description>
            We’re looking for talented, passionate, and creative individuals to
            join our young, dynamic and fast-growing team to help build top
            quality games that bring excitement and financial opportunities for
            people all around the world.
          </Description>
        </Col>
        <Col xs={4}>
          <ImgTitle src={imgpsh} alt="" width={100} />
        </Col>
      </Row> */}
    </Content>
  );
};

export default CareerTitle;
